// Lucide names, stored verbatim on `conversation_assignee_group.icon`.
// Names must exist in LUCIDE_ICONS. Same set as CUSTOM_VIEWS_AVAILABLE_ICONS.
export const ASSIGNEE_GROUP_AVAILABLE_ICONS = [
  'inbox',
  'layers',
  'clipboard-check',
  'list-checks',
  'home',
  'id-card',
  'users',
  'line-chart',
  'alert-circle',
  'calendar-clock',
  'alert-octagon',
  'bar-chart-3',
  'trending-up',
  'move-right',
  'calendar-check',
  'flag',
  'gallery-horizontal-end',
  'package',
  'hourglass',
  'headphones',
  'bug',
  'alert-triangle',
  'check-circle',
  'sparkles',
  'tag',
  'calendar-days',
  'shield-check',
  'globe',
  'thermometer',
  'zap',
  'dollar-sign',
  'layout-dashboard',
  'pin',
  'folder',
];
